module.exports = __webpack_public_path__ + "img/big-room1.403e87c9.png";